import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { ClientPresetProvider } from '@/contexts/ClientPresetContext'
import LoginPage from '@/pages/LoginPage'
import UploadPage from '@/pages/UploadPage'
import VariantsPage from '@/pages/VariantsPage'
import CampaignPage from '@/pages/CampaignPage'
import DashboardPage from '@/pages/DashboardPage'
import ClientPresetsPage from '@/pages/ClientPresetsPage'
import AdvancedCampaignPage from '@/pages/AdvancedCampaignPage'
import AnalyticsPage from '@/pages/AnalyticsPage'
import UserManagement from '@/pages/UserManagement'
import AssetEditorPage from '@/pages/AssetEditorPage'
import InvestorDashboardPage from '@/pages/InvestorDashboardPage'
import InvestorManagement from '@/pages/InvestorManagement'
import Layout from '@/components/Layout'
import InvestorLayout from '@/components/InvestorLayout'

function App() {
  const { user, loading } = useAuth()
  const role = user?.role?.toLowerCase()

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-systemGroupedBackground)',
        fontFamily: 'var(--font-family-appleSystem)',
      }}>
        <div style={{
          width: 'var(--spacing-6)',
          height: 'var(--spacing-6)',
          border: 'var(--border-width-accent) solid var(--color-tertiaryLabel)',
          borderTop: 'var(--border-width-accent) solid var(--color-primary)',
          borderRadius: 'var(--border-radius-full)',
          animation: 'spin var(--duration-slow) linear infinite',
        }}></div>
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  if (role === 'investor') {
    return (
      <InvestorLayout>
        <Routes>
          <Route path="/investor" element={<InvestorDashboardPage />} />
          <Route path="*" element={<Navigate to="/investor" replace />} />
        </Routes>
      </InvestorLayout>
    )
  }

  return (
    <ClientPresetProvider>
      <Layout>
        <Routes>
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/asset-editor" element={<AssetEditorPage />} />
          <Route path="/variants/:batchId" element={<VariantsPage />} />
          <Route path="/campaign" element={<CampaignPage />} />
          <Route path="/advanced-campaign" element={<AdvancedCampaignPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/presets" element={<ClientPresetsPage />} />
          <Route path="/users" element={role === 'admin' ? <UserManagement /> : <Navigate to="/upload" replace />} />
          <Route path="/investors" element={role === 'admin' ? <InvestorManagement /> : <Navigate to="/upload" replace />} />
          <Route path="/dashboard/:campaignId" element={<DashboardPage />} />
          <Route path="/" element={<Navigate to="/upload" replace />} />
          <Route path="*" element={<Navigate to="/upload" replace />} />
        </Routes>
      </Layout>
    </ClientPresetProvider>
  )
}

export default App 